import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  viewButton: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1),
  },

  summaryItem: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '12px',
    marginRight: theme.spacing(2),
  },

  summaryText: {
    marginLeft: theme.spacing(0.5),
  },

  detailSection: {
    padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  },

  history: {
    fontSize: '18px',
    fontFamily: 'Source Sans Pro Semibold',
  },

  sectionHeader: {
    fonsSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
  },
})
